import * as React from "react";
import { styled } from "@mui/material";
import { QuestionsIF } from "../../QuestionsIF";
import { DocQuestion } from "../../DocQuestion";
import { VisitTypeOverlay } from "./visitTypeOverlay";

//region [[ Styles ]]

const VisitTypeQuestionView = styled("div")({});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface VisitTypeQuestionProps extends QuestionsIF {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const VisitTypeQuestion = ({ ...props }: VisitTypeQuestionProps) => {
  return (
    <VisitTypeQuestionView>
      <DocQuestion
        text={props.question?.question?.text}
        miniView={props.miniView}
      />
      {!props.answer && <VisitTypeOverlay {...props} />}
    </VisitTypeQuestionView>
  );
};
